export default class CheckoutError extends Error {}
